import scrollIntoView from './scrollIntoView';

const postProcessFunctions = {
  SCROLL_INTO_VIEW: scrollIntoView,
};

export default postProcessFunctions;
